import React from "react";
import "../../styles/components/marketplace-shared.css";

const HighlightPanel = ({
  eyebrow,
  title,
  description,
  metrics = [],
  icon,
  tone = "info",
  className = "",
}) => (
  <div className={`marketplace-highlight-panel marketplace-highlight-panel--${tone} ${className}`.trim()}>
    <div className="marketplace-highlight-panel__copy">
      {eyebrow ? <span className="marketplace-highlight-panel__eyebrow">{eyebrow}</span> : null}
      <strong className="marketplace-highlight-panel__title">
        {icon ? <i className={`fa ${icon} m-r-8`}></i> : null}
        {title}
      </strong>
      {description ? <p className="marketplace-highlight-panel__description">{description}</p> : null}
    </div>

    {metrics.length > 0 ? (
      <div className={`marketplace-highlight-panel__metrics marketplace-highlight-panel__metrics--count-${metrics.length}`}>
        {metrics.map((metric) => (
          <div key={metric.label}>
            <span>{metric.label}</span>
            <strong>{metric.value}</strong>
            {metric.helper ? <small>{metric.helper}</small> : null}
          </div>
        ))}
      </div>
    ) : null}
  </div>
);

export default HighlightPanel;


